import React, {Component} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faWarehouse, faBuilding, faHome, faSwimmer, faHouseUser, faHandSparkles, faGem, faRoad, faUser, faTruckPickup, faHandshake} from '@fortawesome/free-solid-svg-icons'
import Matomo from '../Matomo';
import { CSSTransition } from 'react-transition-group';
import { FooterLogo } from './FooterLogo';
import { values } from 'lodash';
import { FooterContact } from './FooterContact';
import GPTModal from '../general_questions/modals/GPTmodal'
import AI_Assistant_Icon from '../general_questions/images/J.png'
import MultipleChoiceText from './MultipleChoiceText';
import { findIndexByProperty, findObjectByProperty } from '../../Helpers';

export class JobType extends Component {

    constructor () {
        super();
        this.state = {
            mounted: false,
            all_choices: [],
        }
    }

    componentDidMount = () => {
        // /*-Matomo Analytics-*/
        // const title = 'JobType';
        // Matomo(title);
        // /*----End Matomo----*/

        //Skip to next page if only one option:
        if(this.props.values_business && this.props.values_business.jobtype_options.length === 1){
            const event = new Event("service");
            event.data=this.props.values_business.jobtype_options[0];
            this.props.handleChangeObjectNext(this.props.next, 'jobtype', this.props.values_business.jobtype_options[0], true);
        }
        
        let all_choices = this.props.values_business.jobtype_options.concat(
            Array.isArray(this.props.values_business.custom_flows) ? this.props.values_business.custom_flows : []
        );
        this.setState({ mounted: true, all_choices: [...all_choices] });
    }

    getFaIcon = (title) => {

        switch(title.toLowerCase()){
            case "garage":
            case "traditional epoxy":
                return faWarehouse;
            case "commercial space":
                return faBuilding;
            case "pool deck":
                return faSwimmer;
            case "home exterior":
            case "exterior project":
                return faHome;
            case "home interior":
            case "interior project":
                return faHouseUser;
            case "concrete polishing":
                //return faHandSparkles;
                return faGem;
            case "epoxy floor striping":
                return faRoad;
            case "diy project":
            case "diy garage":
                return faUser;
            case "grinder rental":
                return faTruckPickup;
            case "grind prep service (garage)":
                //return faRoadSpikes;
                return faHandshake;

        }
    }
    
    getNextPageTitle = (job_title) => {
        //if job title is included anywhere in custom_flow array, return the next page title
        const {custom_flows} = this.props.values_business;
        console.log(job_title + " clicked")
        const iscustom = findIndexByProperty(custom_flows, 'title', job_title);
            if(iscustom > -1){
                return "Custom Flow: " + job_title;
            }
        //else return the default next page title
        return this.props.next;
    }

    render() { 
        const { handleChangeObjectNext, handleChangeEstimateReason, nextPage, next, values_business, values_customer, is_mobile_display, pages } = this.props;
        const { all_choices, visibleItemsCount, scrollPosition, scrollOffset, itemWidth } = this.state;

        return (
            
            <MultipleChoiceText
                key={this.state.all_choices}
                page_title = {'Job Type'}
                handleChangeObjectNext={handleChangeObjectNext}
                handleChangeEstimateReason={handleChangeEstimateReason}
                showpage = {true}
                nextPage={nextPage}
                default_next = {next}
                header_question = {'What kind of work are you interested in?'}
                default_state_var = {'jobtype'}
                choices = {all_choices.map((job) => (
                    {title: job.title,
                        icon: this.getFaIcon(job.title),
                        value: findObjectByProperty(values_business.jobtype_options, "title", job.title), 
                        nextpage: this.getNextPageTitle(job.title), 
                        state_var: "jobtype"
                    }
                ))}
                values_customer={values_customer} 
                values_business={values_business}
                is_mobile_display={is_mobile_display}
            />
        )
    }
}

export default JobType;